// Content.js
import "../styling/Content.css";
import AccountInfo from "./AccountInfo";
import Analytics from "./Analytics";
import Bookings from "./Bookings";
import BoothInfo from "./BoothInfo";
import BusinessClientEvent from "./clientPortal/BusinessClientEvent";
import Calendar from "./Calender";
import Clients from "./Clients";
import CompanyInfo from "./CompanyInfo";
import Dashboard from "./Dashboard";
import { useEffect } from "react";

const Content = ({
  selectedMenuItem,
  handleClientClick,
  onEventClick,
  rightPaneEventClick,
  onPanelEventClick,
  handleViewAllClick,
  setSelectedMenuItem, // Add setSelectedMenuItem prop
  clientRecord,
  setInitialBusinessEventTab,
  initialBusinessEventTab,
  setRightSidebar,

}) => {


 

  

  useEffect(() => {
    setRightSidebar?.(null);
    return () => setRightSidebar?.(null);
  }, [selectedMenuItem, setRightSidebar]);

  const handleAccountInfoChange = (infoType) => {
    if (
      infoType === "account" ||
      infoType === "company" ||
      infoType === "booth"
    ) {
      setSelectedMenuItem(infoType);
    }
  };
  let contentComponent;
  switch (selectedMenuItem) {
    case "Dashboard":
      contentComponent = (
        <Dashboard
          rightPaneEventClick={rightPaneEventClick}
          onPanelEventClick={onPanelEventClick}
          setSelectedMenuItem={setSelectedMenuItem}
          handleViewAllClick={handleViewAllClick}
          onEventClick={onEventClick}
          setInitialBusinessEventTab={setInitialBusinessEventTab}
          setRightSidebar={setRightSidebar}
        />
      );
      break;
    case "Events":
      contentComponent = <Bookings onEventClick={onEventClick} setInitialBusinessEventTab={setInitialBusinessEventTab} />;
      break;
    case "Clients":

      contentComponent = <Clients handleClientClick={handleClientClick} clientRecord={clientRecord} onEventClick={onEventClick} setInitialBusinessEventTab={setInitialBusinessEventTab} setRightSidebar={setRightSidebar} />;

      break;
    case "Analytics":
      contentComponent = <Analytics setRightSidebar={setRightSidebar} />;
      break;
    case "Calendar":
      contentComponent = <Calendar onEventClick={onEventClick} />;
      break;
    case "account":
      contentComponent = (
        <AccountInfo
          onClickAccountInfoButton={handleAccountInfoChange}
          initialSelected={selectedMenuItem}
        />
      );
      break;
    case "company":
      contentComponent = (
        <CompanyInfo onClickAccountInfoButton={handleAccountInfoChange}
         />
      );
      break;
    case "booth":
      contentComponent = (
        <BoothInfo onClickAccountInfoButton={handleAccountInfoChange} />
      );
      break;
    case "businessEvent":
      contentComponent = <BusinessClientEvent initialBusinessEventTab={initialBusinessEventTab} setRightSidebar={setRightSidebar}/>;
      break;
    default:
      contentComponent = (
        <Dashboard
          rightPaneEventClick={rightPaneEventClick}
          onPanelEventClick={onPanelEventClick}
          handleViewAllClick={handleViewAllClick}
          setSelectedMenuItem={setSelectedMenuItem} // Pass setSelectedMenuItem to Dashboard
          onEventClick={onEventClick}
          setInitialBusinessEventTab={setInitialBusinessEventTab}
          setRightSidebar={setRightSidebar}
        />
      );
  }
  return <div className="content">{contentComponent}</div>;
};

export default Content;
